export enum ErrorType {
  AW_SNAP = 'aw-snap',
  AUTH_ERROR = 'auth-error',
  NOT_AUTHORISED = 'not-authorised',
  NETWORK_ERROR = 'network-error',
  MAXIMUM_NUMBER_OF_ROOMS_REACHED = 'maximum-number-of-rooms-reached',
  ROOM_NOT_AVAILABLE = 'room-not-available',
  FAILED_TO_DELETE_ROOM_NOT_EMPTY = 'failed-to-delete-room-not-empty'
}